<template>
	<div>
		
		<div class="query">
			<div class="checkbox">
				
			</div>
			<!-- <Input search enter-button placeholder="用户id/卡片编号" v-model="query.like" style="width: 500px;"  @on-search="onsearch"/> -->
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				
					<!-- <Button type="primary" size="small" style="margin-right: 5px" v-show="row.state==false" @click="update(row.id)">已处理</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				units:[],
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					state:'bx',
					like:'',
					unitId:''
				},
				number:'',
				unitId:'',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '标识',
						key: 'uuid'
					},
					{
						title: '状态',
						key: 'macUuidStatetoString'
					},
					{
						title: '设备信息',
						key: 'macLeaveFactoryId'
					},
					{
						title: '分配时间',
						key: 'allocationTime'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center'
					}
				],
				data6: [
					
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			update(id){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/client/join/update',
				    data: {
						id:id
					},
					_this: _this,
					success: function(data) {
						_this.ajaxPage()
						
						_this.$Message.success('修改成功！！！');
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/uuid/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macUuids.totalElements
						_this.data6 = data.macUuids.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/uuid/list.vue